import type { VoucherApplyResult, VoucherType } from '../../domain/vouchers/types'
import type { ApplyVoucherPaymentResponse, VoucherApi } from './types'

export function mapVoucherApiToDomain(voucher: VoucherApi): VoucherType {
  return {
    voucherCode: voucher.voucherCode,
    email: voucher.email,
    birthdate: voucher.birthdate,
    expirationDate: voucher.expirationDate,
    isActive: voucher.isActive,
    canBeUsed: voucher.canBeUsed,
    cannotBeUsedReasons: voucher.cannotBeUsedReasons,
    amountText: voucher.amountText,
    amount: voucher.amount.value,
    currencySymbol: voucher.amount.currencySettings?.symbol ?? '',
    bonusAmountLabel: voucher.bonus?.amountLabel,
    bonusLabel: voucher.bonus?.bonusLabel,
  }
}

export function mapVoucherApplyResponseApiToDomain(response: ApplyVoucherPaymentResponse): VoucherApplyResult {
  return {
    isVoucherFullyRedeemed: response.isVoucherFullyRedeemed,
    isBookingFullyPaid: response.isBookingFullyPaid,
    isBookingDepositPaid: response.isBookingDepositPaid,
    booking: {
      amount: response.amounts.bookingAmount,
      restAmount: response.amounts.bookingRestAmount,
    },
    deposit: {
      amount: response.amounts.depositBookingAmount,
      restAmount: response.amounts.depositRestAmount,
    },
    voucher: {
      totalAmount: response.amounts.voucherTotalAmount,
      transactionAmount: response.amounts.voucherTransactionAmount,
      remainingAmount: response.amounts.voucherRemainingAmount,
    },
    urlRedirect: response.urlRedirect,
  }
}
